/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getPlayerProfileBySeason = function (seasonId,playerId) 
{
    const endpoint = `/${seasonId}/${playerId}/playerprofile`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 


// WEBPACK FOOTER //
// ./src/components/pages/api/getPlayerProfileBySeason.js